export default __webpack_public_path__ + "static/media/josef-widder.5550888a.jpeg";